import dayjs from "dayjs";

export const parsePurchaseSupplierSkus = (data: any[]): any[] => {
  const res = [];

  for (const item of data) {
    res.push({
      "pedido-id": item.productId,
      "pedido-supplier-cod": item.supplierProductCode,
      "pedido-color": "red",
      "pedido-centro": item.storeId + " - " + item.storeDescription,
      "pedido-status": item.statusDeliveryDate,
      "pedido-numero": item.documentId,
      "pedido-codigo": item.productId,
      "pedido-codigo-fornecedor": item.supplierProductCode,
      "pedido-nome-produto": item.productDescription,

      "quantidade-total": item.orderedQuantity,
      "quantidade-entregue": item.receivedQuantity,
      "quantidade-pendente": item.quantityToSupply,
      "quantidade-agendada": item.quantityScheduled,
      "quantidade-pedente-agendada": item.quantityPendingScheduling,
      "quantidade-agendar": item.quantitySchedule,
      "data-prevista": dayjs(item.expectedDeliveryDate).format("DD/MM/YYYY "),
    });
  }

  return res;
};
